import './App.css';
import {Route, Routes} from "react-router-dom";
import GetUuidActivity from "./components/Activity/GetUuidActivity";
import GetUuidBoxActivity from "./components/Activity/GetUuidBoxActivity";
import GetIdsStartActivity from "./components/Activity/GetIdsStartActivity";
import GetIdsActivity from "./components/Activity/GetIdsActivity";
import NotFound from "./components/Error/NotFound";

function App() {
  return (
      <Routes>
        <Route path="/" element={<Client/>}/>
        <Route path="/activity/find/:uuid" element={<GetUuidActivity />} />
        <Route path="/activity/find/:uuid/:user" element={<GetUuidActivity />} />
        <Route path="/activity/box/:uuid" element={<GetUuidBoxActivity/>}/>
        <Route path="/activity/start/:activity/:user" element={<GetIdsStartActivity/>}/>
        <Route path="/activity/:activity/:user" element={<GetIdsActivity/>}/>
        <Route path="/error" element={<NotFound/>}/>
        <Route path="*" element={<NotFound/>}/>
      </Routes>
  );
}

function Client() {
    // 👇️ redirect to external URL
    window.location.replace(process.env.REACT_APP_CLIENT_URL);

    return null;
}

export default App;
